export default {
  setSelectedSchoolYearSuccess (state, selectedSchoolYear) {
    state.schoolYear = selectedSchoolYear
  },
  getSchoolYearsRequest (state) {
    state.loading = true
    state.schoolYears = []
  },
  getSchoolYearsSuccess (state, data) {
    state.loading = false
    state.schoolYears = data
  },
  getSchoolYearsFailure (state) {
    state.loading = true
    state.schoolYears = []
  },
  getOpenSchoolYearRequest (state) {
    state.loading = true
    state.schoolYear = {}
  },
  getOpenSchoolYearSuccess (state, data) {
    state.loading = false
    state.schoolYear = data
  },
  getOpenSchoolYearFailure (state) {
    state.loading = true
    state.schoolYear = {}
  },
  getOverallStatisticsRequest (state) {
    state.loading = true
    state.statistics = {}
  },
  getOverallStatisticsSuccess (state, data) {
    state.loading = false
    state.statistics = data
  },
  getOverallStatisticsFailure (state) {
    state.loading = true
    state.statistics = {}
  }
}
